import validator from 'validator'

import { normalizeStringValue } from '../../../../../helpers/normalizers'

export default {
  applicant_proposal_solution: {
    label:
      'Escreva em uma frase o que sua solução faz? (máximo 140 caracteres) *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_proposal_solution,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_proposal_demo_video_url: {
    label: 'Insira o link do Youtube do seu Vídeo Demo com até 2 min. *',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_proposal_demo_video_url,
      )
    },
    validate(fieldId, formData) {
      if (validator.isEmpty(formData[fieldId])) {
        return { [fieldId]: 'blank' }
      }

      if (!validator.isURL(formData[fieldId])) {
        return { [fieldId]: 'invalid_url' }
      }
      return {}
    },
  },
  attachment_a: {
    label:
      'Insira o seu slide resumo preenchido com as informações da sua equipe *',
    initialValue: '',
    parseRegistration() {
      return null
    },
    validate(fieldId, formData) {
      if (!formData[fieldId]) {
        return { [fieldId]: 'blank' }
      }
      return {}
    },
  },
  applicant_proposal_app_inventor_url: {
    label:
      'Insira o link da sua solução desenvolvida no aplicativo App Inventor (opcional)',
    initialValue: '',
    parseRegistration(registrationData) {
      return normalizeStringValue(
        registrationData.extra_data.applicant_proposal_app_inventor_url,
      )
    },
    validate(fieldId, formData) {
      if (!validator.isEmpty(formData[fieldId])) {
        if (!validator.isURL(formData[fieldId])) {
          return { [fieldId]: 'invalid_url' }
        }
      }
      return {}
    },
  },
}
